module.exports = __webpack_public_path__ + "static/media/10.6d3140a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/hats/400/10.png
// module id = 730
// module chunks = 0